
export const MessageTypes = {
    error: 'error',
    info: 'info',
    success: 'success',
}

const Message = () => {
    const toastContainer = document.querySelector('.toast-container');
    const setupListeners = () => {
        document.body.addEventListener( 'click', function ( event ) {
            if( event.target.classList.contains('close-toast')) {
                event.target.parentNode.parentNode.remove();
            }
        })
    }

    const messageTpl = (status, message) => {
        return `
            <div class="toast fade show" role="alert" aria-live="assertive" aria-atomic="true">
                <div class="toast-header">
                  <span class="toast__square toast__square--${status}"></span>
                  <strong class="toast__status ">${status}</strong>
                  <small class="text-body-secondary">just now</small>
                  <button type="button" class="btn-close close-toast" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
                <div class="toast-body">
                  ${message}
                </div>
            </div>
        `
    };

    const displayMessage = (status, message, container = toastContainer) => {
        if (status === MessageTypes.error && !message) {
            message = 'Something went wrong! Please try again later.'
        }

        container.insertAdjacentHTML('beforeend', messageTpl(status, message));
    }

    const init = () => {
        setupListeners();

        return {
            displayMessage: displayMessage,
        }
    }

    return {
        init: init,
    }
}

export default Message;
